import React from 'react'

const About = () => (
  <div>
    <h1>About Us</h1>
    <p>Hello Medium!</p>
  </div>
)

export default About 



// WEBPACK FOOTER //
// ./src/containers/about/index.js